import React from "react";
import { Form } from "semantic-ui-react";
import { Editor } from "@tinymce/tinymce-react";
import { useFormik } from "formik";
import { supportAPI } from "../../../api";
import { initialValues, validationSchema } from "./SupportForm.form";
import "./SupportForm.scss";
import { ENV } from "../../../Utils/constants";

const supportController = new supportAPI();

export function SupportForm(props) {
  const { onClose, onReload, ticket, accessToken, user } = props;

  // Si no tenemos ticket, es creación
  const isCreation = !ticket;
  const mainButtonText = isCreation ? "Crear Ticket" : "Responder Ticket";

  const formik = useFormik({
    initialValues: initialValues(ticket),
    validationSchema: validationSchema(isCreation),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (isCreation) {
          // CREAR TICKET
          const dataToSend = {
            title: formValue.title,
            description: formValue.description,
            message: formValue.message,
            clientInputId: user.user._id, // Ajusta la ruta si es user.user._id
            clientOutputId: user.user.partner, // Partner ID
            senderRole: user.user.role,
          };
          await supportController.createTicket(accessToken, dataToSend);
        } else {
          // RESPONDER TICKET

          // Escoge user.user si existe, o user en caso contrario
          const actualUser =
            user && user.user && typeof user.user === "object"
              ? user.user
              : user;

          // Ahora construye el payload siempre desde actualUser
          const dataToSend = {
            userId: actualUser._id,
            senderRole: actualUser.role,
            message: formValue.message,
          };

          await supportController.respondTicket(
            accessToken,
            ticket._id,
            dataToSend
          );
        }

        onReload();
        onClose();
      } catch (error) {
        console.log(error);
      }
    },
  });

  return (
    <Form className="support-form" onSubmit={formik.handleSubmit}>
      {/* Campos solo visibles en creación */}
      {isCreation && (
        <>
          <Form.Field>
            <label>Título del ticket</label>
            <Form.Input
              name="title"
              placeholder="Ej. Problema con la plataforma"
              onChange={formik.handleChange}
              value={formik.values.title}
              error={formik.errors.title}
            />
          </Form.Field>

          <Form.Field>
            <label>Descripción del ticket</label>
            <Form.Input
              name="description"
              placeholder="Ej. Ocurre un error al intentar..."
              onChange={formik.handleChange}
              value={formik.values.description}
              error={formik.errors.description}
            />
          </Form.Field>
        </>
      )}

      <Form.Field>
        <label>{isCreation ? "Mensaje inicial" : "Respuesta"}</label>
        <Editor
          apiKey={ENV.TINY_APIKEY}
          init={{
            height: 300,
            menubar: true,
            plugins: [
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code fullscreen",
              "insertdatetime media table paste code help wordcount",
            ],
            toolbar:
              "undo redo | formatselect | bold italic backcolor | " +
              "alignleft aligncenter alignright alignjustify | " +
              "bullist numlist outdent indent | removeformat | help",
          }}
          initialValue={formik.values.message}
          onBlur={(e) => formik.setFieldValue("message", e.target.getContent())}
        />
      </Form.Field>

      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {mainButtonText}
      </Form.Button>
    </Form>
  );
}
